/* global axios */
import ApiClient from './ApiClient';

class McpServersAPI extends ApiClient {
  constructor() {
    super('navi_mcp_servers', { accountScoped: true });
  }

  // Get all MCP servers with types and categories
  get() {
    return axios.get(this.url);
  }

  // Get a specific MCP server
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // Create a new MCP server
  create(data) {
    return axios.post(this.url, {
      navi_mcp_server: data,
    });
  }

  // Update an MCP server
  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      navi_mcp_server: data,
    });
  }

  // Delete an MCP server
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Test connection to an MCP server
  testConnection(id) {
    return axios.post(`${this.url}/${id}/test_connection`);
  }

  // Sync tools from an MCP server
  syncTools(id) {
    return axios.post(`${this.url}/${id}/sync_tools`);
  }

  // Get server types catalog
  getServerTypes() {
    return axios.get(`${this.url}/server_types`);
  }

  // Get tools for a specific server type
  getServerTypeTools(serverType) {
    return axios.get(`${this.url}/server_types/${serverType}/tools`);
  }
}

export default new McpServersAPI();
